var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.085 22.164C4.972 22.164 0 17.194 0 11.082 0 4.97 4.972 0 11.085 0 17.2 0 22.17 4.97 22.17 11.082c0 6.111-4.971 11.082-11.085 11.082Zm0-21.386C5.397.778.778 5.396.778 11.082c0 5.676 4.62 10.304 10.307 10.304 5.678 0 10.307-4.628 10.307-10.304 0-5.686-4.63-10.304-10.307-10.304Zm0 16.955a.394.394 0 0 1-.394-.394V8.477a.394.394 0 1 1 .789 0v8.862a.4.4 0 0 1-.395.394Zm0-11.694c.332 0 .602-.28.602-.612a.59.59 0 0 0-.602-.602.605.605 0 0 0-.612.602c0 .342.28.612.612.612Z",
    fill: "#FFFFFD"
  })));
};
export default SvgInfo;